<template>
    <div>
        <!-- Modal -->
        <b-modal id="deleteModal" title="eliminar usuario" size="xl" centered scrollable header-bg-variant="dark"
            v-model="modalShow" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    cerrar
                </b-button>

            </template>

            <AlertDismiss ref="alertDismiss"></AlertDismiss>

            <div class="d-block text-center">
                <h3>¿Desea eliminar el usuario?</h3>
                <b-button class="mt-3" variant="outline-danger" block @click="eliminarUsuario()">
                    <b-spinner v-if="process" small></b-spinner>
                    Eliminar
                </b-button>
            </div>

        </b-modal>
    </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

export default {
    name: 'UserDelete',

    data() {
        return {
            modalShow: false,
            user: null,
            process: false,
        }
    },

    components: {
        AlertDismiss
    },

    mounted() {
        this.$eventBus.$on(EventNames.OpenModalDeleteUser, (query) => {
            this.user = query[0];
            this.openModal();
        });
    },

    methods: {
        ...mapActions(["deleteUser"]),

        openModal() {
            this.modalShow = true;
        },
        closeModal() {
            this.modalShow = false;
        },

        processing() {
            this.process = !this.process;
        },

        async eliminarUsuario(){
            this.processing();

            let result = await this.deleteUser({ id: this.user.id });

            if(result.isError){
                this.$refs.alertDismiss.showAlert(result.message);
                this.processing();
                return;
            }

            this.closeModal();
            this.processing();

            this.$eventBus.$emit(EventNames.DeleteUser, {
                mail: this.user.mail, 
                page: 1, 
                pageSize: InitPageSize.UsersPageSize});
        }
    }
}
</script>
<style></style>